import { render, staticRenderFns } from "./MainMenu.vue?vue&type=template&id=658a8948&scoped=true"
import script from "./MainMenu.vue?vue&type=script&lang=js"
export * from "./MainMenu.vue?vue&type=script&lang=js"
import style0 from "./MainMenu.vue?vue&type=style&index=0&id=658a8948&prod&lang=stylus"
import style1 from "./MainMenu.vue?vue&type=style&index=1&id=658a8948&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "658a8948",
  null
  
)

export default component.exports